import React from 'react';
import "../assets/Home.css";

import arrow from "../assets/arrow.svg";

const Section1 = () => {
  return (
    <div className="section">
      <h1 className='websiteTitle'>establishing.</h1>
      <h1 className='byVeditBeladia'>by VEDIT BELADIA</h1>
      <h1 className='Portfolio'>PORTFOLIO 2024</h1>
      <p className="sec1Text">WEB DEVELOPER<br />DATA ANALYST<br />UI/UX DESIGNER<br />PHOTOGRAPHER<br />GRAPHIC DESIGNER</p>
      <img className='arrow1' src={arrow} alt='arrow' />
    </div>
  );
};

export default Section1;
